/*
 * @Author: Mike Cottingham 
 * @Date: 2018-04-24 23:36:31 
 * @Last Modified by: Mike Cottingham
 * @Last Modified time: 2018-05-16 15:16:02
 */

import React, { Component } from "react"
import { TextField, Button } from "material-ui"
import ClientSearch from "./ClientSearch"
import PropTypes from "prop-types"
import core from "../../core"


class ClientAppointmentSearch extends Component {
  constructor(props) {
    super(props)

    this.state = this.generateState()
    this.formRef = React.createRef()

    this.onChange = core.utils.onChange.bind(this)
    this.validate = core.utils.validate.bind(this)
    this.onSubmit = this.onSubmit.bind(this)
    this.onClientChange = this.onClientChange.bind(this)
  }

  onSubmit(e) {
    e.preventDefault()
    this.setState((prevState, props) => {
      props.onSubmit(prevState)
      return prevState
    })
  }

  onClientChange(search, client) {
    if(client) {
      this.setState({
        firstName: client.firstName,
        lastName: client.lastName,
        search: `${client.firstName} ${client.lastName}`
      })
    } else {
      this.setState({search, firstName:search, lastName:""})
    }
  }

  generateState() {
    return {
      firstName: "",
      lastName: "",
      minDate: "",
      maxDate: "",
      search: ""
    }
  }

  render() {
    const {loading} = this.props
    
    return (
      <section>
        <form className="flex" onSubmit={this.onSubmit} ref={this.formRef}>
          <ClientSearch className="flex-37-5" onChange={this.onClientChange} value={this.state.search} selected={this.state.lastName !== ""} />
          <TextField
            className="flex-20 standard-margin"
            id="minDate"
            label={"Minimum Date"}
            type="date"
            name="minDate"
            margin="normal"
            onChange={this.onChange}
            value={this.state.minDate}
            InputLabelProps={{ shrink: true, required: true }}
            max={this.state.maxDate}
            InputProps={{inputProps: { max: this.state.maxDate}}}
          />
          <TextField
            className="flex-20 standard-margin"
            id="maxDate"
            label={"Maximum Date"}
            type="date"
            name="maxDate"
            margin="normal"
            onChange={this.onChange}
            value={this.state.maxDate}
            InputLabelProps={{ shrink: true, required: true }}
            InputProps={{inputProps: { min: this.state.minDate}}}
          />
          <Button  
            onClick={this.onSubmit} 
            color="primary" 
            variant="raised" 
            type="submit" 
            style={{width: 220, margin: '0 20px'}}
            disabled={!this.state.maxDate || !this.state.minDate || loading}
          >
            Search
          </Button >&nbsp;
        </form>
      </section>
    )
  }
}

ClientAppointmentSearch.propTypes = {
  onSubmit: PropTypes.func,
  loading: PropTypes.bool
}

export default ClientAppointmentSearch